export const leaveAfterComma = (value, count) => {
  return typeof value === "number" ? +value.toFixed(count) : value;
};
